import { render, staticRenderFns } from "./ManageMobileApp.vue?vue&type=template&id=27fd10f3&scoped=true"
import script from "./ManageMobileApp.vue?vue&type=script&lang=ts"
export * from "./ManageMobileApp.vue?vue&type=script&lang=ts"
import style0 from "./ManageMobileApp.vue?vue&type=style&index=0&id=27fd10f3&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "27fd10f3",
  null
  
)

export default component.exports